import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Button, Error404Crack, Error404Desert, Error404Vulture, HFlex, HGrid, Heading, Text, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const images = [Error404Crack, Error404Desert, Error404Vulture];
const Container = styled.div.withConfig({
  displayName: "NotFound__Container"
})(["align-items:center;background-color:", ";display:flex;justify-content:center;padding:", ";"], tombac.color('neutral', 200), tombac.space(20));
const NotFound = () => {
  const [Image, setImage] = useState('div');
  useEffect(() => {
    // Set a random image
    setImage(() => images[Math.round(Math.random() * (images.length - 1))]);
  }, []);
  return /*#__PURE__*/_jsx(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "NotFound",
    "data-sentry-source-file": "NotFound.tsx",
    children: /*#__PURE__*/_jsxs(HFlex, {
      alignItems: "center",
      "data-sentry-element": "HFlex",
      "data-sentry-source-file": "NotFound.tsx",
      "data-sentry-element": "HFlex",
      children: [/*#__PURE__*/_jsx(Image, {
        width: 480,
        "data-sentry-element": "Image",
        "data-sentry-source-file": "NotFound.tsx",
        "data-sentry-element": "Image"
      }), /*#__PURE__*/_jsxs(Box, {
        $ml: "3sp",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "NotFound.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h1",
          level: 1,
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "NotFound.tsx",
          "data-sentry-element": "Heading",
          children: "Oops!!!"
        }), /*#__PURE__*/_jsx(Heading, {
          as: "div",
          level: 3,
          $maxWidth: "30sp",
          $mt: "1sp",
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "NotFound.tsx",
          "data-sentry-element": "Heading",
          children: "This is not the page you are looking for"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "secondary",
          $mt: "2sp",
          "data-sentry-element": "Text",
          "data-sentry-source-file": "NotFound.tsx",
          "data-sentry-element": "Text",
          children: "Here are some helpful links instead:"
        }), /*#__PURE__*/_jsxs(HGrid, {
          $mt: "2sp",
          "data-sentry-element": "HGrid",
          "data-sentry-source-file": "NotFound.tsx",
          "data-sentry-element": "HGrid",
          children: [/*#__PURE__*/_jsx(Button, {
            as: Link,
            to: "/",
            variant: "primary",
            "data-sentry-element": "Button",
            "data-sentry-source-file": "NotFound.tsx",
            "data-sentry-element": "Button",
            children: "Back to home"
          }), /*#__PURE__*/_jsx(Button, {
            as: "a",
            href: "https://developer.tomtom.com/move-portal/guides/introduction",
            target: "_blank",
            "data-sentry-element": "Button",
            "data-sentry-source-file": "NotFound.tsx",
            "data-sentry-element": "Button",
            children: "MOVE support"
          })]
        })]
      })]
    })
  });
};
export default NotFound;